import { Dialog, Stack } from '@mui/material';
import classnames from 'classnames';
import React, { type PropsWithChildren } from 'react';

import { Loader } from '@/components/shared/loader';

import { PanelWrapper, type PanelWrapperProps } from '../panels/panelWrapper';

export interface MainDialogProps extends PanelWrapperProps {
  isOpen: boolean;
  isLoading: boolean;
  disableGutters?: boolean;
  /** Render as a full-viewport overlay instead of a centered modal. */
  fullScreen?: boolean;
}

export function MainDialog(props: PropsWithChildren<MainDialogProps>) {
  const {
    isLoading,
    isOpen,
    header,
    footer,
    sx,
    disableGutters = false,
    fullScreen = false,
  } = props;

  return (
    <Dialog
      fullScreen={fullScreen}
      onClose={() => {
        header?.onClose?.();
      }}
      onClick={(event) => event.stopPropagation()}
      open={isOpen}
      slotProps={{
        paper: {
          sx: fullScreen
            ? {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                borderRadius: '0px',
                ...sx,
              }
            : {
                width: '40%',
                maxWidth: '840px',
                minWidth: '600px',
                height: 'max-content',
                minHeight: '300px',
                maxHeight: '90vh',
                borderRadius: '16px',
                ...sx,
              },
        },
      }}
    >
      <PanelWrapper
        rounded
        header={header ? { ...header } : undefined}
        footer={footer ? { ...footer } : undefined}
      >
        <Stack
          className={classnames('h-full', {
            'py-[24px]': !disableGutters,
          })}
        >
          {isLoading && <Loader />}
          {!isLoading && <>{props.children}</>}
        </Stack>
      </PanelWrapper>
    </Dialog>
  );
}
